'use client';

import { useHeaderHeight } from '@/app/_hooks/useHeaderHeight';
import { useIsClientSide } from '@/app/_hooks/useIsClientSide';
import { useEffect } from 'react';

export const ScrollUtil = () => {
  const headerHeight = useHeaderHeight();
  const isClient = useIsClientSide();

  useEffect(() => {
    if (!headerHeight || !isClient) return;

    const html = document.getElementsByTagName('html')[0];
    html.style.scrollPaddingTop = `${headerHeight}px`;
  });

  return null;
};
